<template>
  <div>
    <div style="margin-bottom: 12px">
      <Input
        v-model="newUserId"
        placeholder="输入新用户ID"
        style="width: 200px; margin-right: 10px"
      />
      <Button type="primary" :loading="loading" @click="handleConfirm"
        >确认</Button
      >
      <Button style="margin-left: 8px" @click="handleClear">清除</Button>
      <div style="margin-left: 8px; color:red">只有3月23号以后注册的用户才需要同步</div>
    </div>

    <pre
      style="white-space: pre-wrap; word-break: break-all; background: #f7f7f7; padding: 12px; border-radius: 4px"
    >{{ resultText }}</pre>
  </div>
</template>

<script>
import { cmsOlderUser } from "../../api/user";

export default {
  components: {  },
  data() {
    return {
      newUserId: "",
      resultText: "",
      loading: false,
    }
  },
  computed: {
    
  },
  watch: {
    
  },
  mounted() {
     
  },
  methods: {
    handleConfirm() {
      const id = (this.newUserId || "").toString().trim();
      if (!id) {
        this.$Message.error("请输入新用户ID");
        return;
      }
      if (isNaN(Number(id))) {
        this.$Message.error("新用户ID必须是数字");
        return;
      }

      this.loading = true;
      cmsOlderUser({
        user_id: Number(id),
        new_user_id: Number(id),
      })
        .then((res) => {
          this.resultText = JSON.stringify(res, null, 2);
        })
        .catch((err) => {
          this.resultText = (err && (err.message || err.toString())) || "请求失败";
          this.$Message.error("请求失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleClear() {
      this.newUserId = "";
      this.resultText = "";
      this.loading = false;
    },
  },
};
</script>
